import { useContext } from 'react';
import { AppConfigContext } from '../contexts/AppConfigContext';
import { AppConfigContextInterface } from '../types/AppConfigContextTypes';

// A custom hook allows us to test better.
export const useAppConfigContext = () => useContext(AppConfigContext) as AppConfigContextInterface;

export default useAppConfigContext;
